<template>
  <YapIcon :name="currencyFlagIcon(currency)" is-flag />
</template>

<script setup lang="ts">
import YapIcon from '@/components/YapIcon.vue';
import useCurrenciesHelper from '@/composables/useCurrenciesHelper';

const props = defineProps<{
  currency: string;
}>();

const { currencyFlagIcon } = useCurrenciesHelper();
</script>
